import { render } from "./lei-user.vue?vue&type=template&id=abd2cf3a&ts=true"
import script from "./lei-user.vue?vue&type=script&lang=ts"
export * from "./lei-user.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__